<template>
  <v-footer app>
    <v-container fluid>
      <v-row justify="center">
        <v-col class="text-center">
          &copy; {{ new Date().getFullYear() }} CoreTrust Agent dashboard
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script setup>
import { defineComponent } from 'vue';
defineComponent({
  name: 'AgentFooter',
});
</script> 